import { render, staticRenderFns } from "./InterestList.vue?vue&type=template&id=35fb4238&scoped=true"
import script from "./InterestList.vue?vue&type=script&lang=js"
export * from "./InterestList.vue?vue&type=script&lang=js"
import style0 from "./InterestList.vue?vue&type=style&index=0&id=35fb4238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb4238",
  null
  
)

export default component.exports